// Handle cart open/close
document.addEventListener('DOMContentLoaded', function () {
  // console.log("Cart JS is working");
  var cartDrawer = document.getElementById('lm-cart-drawer');
  var cartOverlay = document.getElementById('lm-cart-overlay');
  var closeCartBtn = document.getElementById('lm-close-cart-btn');
  var openCartBtn = document.getElementById('open-cart-btn');

  // Function to open the cart drawer
  function openCartDrawer() {
    cartOverlay.style.opacity = 1;
    cartOverlay.style.visibility = 'visible';
    cartDrawer.style.transform = 'translateX(0)';

    document.body.style.overflow = 'hidden';
  }

  // Function to close the cart drawer
  function closeCartDrawer() {
    cartOverlay.style.opacity = 0;
    cartDrawer.style.transform = 'translateX(100%)';
    setTimeout(function () {
      cartOverlay.style.visibility = 'hidden';
    }, 300);

    document.body.style.overflow = 'auto';
  }

  // Event listener for opening the cart drawer (e.g., when clicking a cart icon)
  openCartBtn.addEventListener('click', openCartDrawer);

  // Replace 'open-cart-btn' with the ID or class of the element triggering the cart open
  document
    .getElementById('open-cart-btn')
    .addEventListener('click', openCartDrawer);

  // Event listener for closing the cart drawer (e.g., when clicking the close button)
  closeCartBtn.addEventListener('click', closeCartDrawer);

  // Only close cart when clicking overlay itself, not when clicking inside the drawer
  cartOverlay.addEventListener('click', function (event) {
    // Check if the click target is the overlay itself (not a child element)
    if (event.target === cartOverlay) {
      closeCartDrawer();
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  addRemoveButtonListeners();
});

// Function to update cart display
async function updateCartDrawer() {
  try {
    const response = await fetch('/?section_id=lm-cart');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.text();

    const html = document.createElement('div');
    html.innerHTML = data;

    const newItemContainer = html.querySelector('.lm-cart-items-container');
    const newTotalPrice = html.querySelector('#lm-total-price');

    document.querySelector('.lm-cart-items-container').innerHTML =
      newItemContainer.innerHTML;
    document.querySelector('#lm-total-price').innerHTML =
      newTotalPrice.innerHTML;

    addRemoveButtonListeners();
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
}

// Function to remove variantId from cart
async function removeFromCart(variantId, button) {
  // Disable button and show loading state
  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = 'Removing...';
  button.style.opacity = '0.6';
  button.style.cursor = 'not-allowed';

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [variantId]: 0,
        },
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to remove item from cart');
    }

    const responseData = await response.json();
    console.log('Item removed from cart:', responseData);

    // Update the cart display after successful removal
    await updateCartDrawer();

    return responseData;
  } catch (error) {
    console.error('Error removing item from cart:', error);

    // Re-enable button on error
    button.disabled = false;
    button.textContent = originalText;
    button.style.opacity = '1';
    button.style.cursor = 'pointer';

    // Show error message to user
    alert('Failed to remove item from cart. Please try again.');
  }
}

// Function to add event listeners for remove buttons
function addRemoveButtonListeners() {
  document.querySelectorAll('.lm-cart-remove-btn').forEach((button) => {
    button.addEventListener('click', async function (event) {
      // Prevent event from bubbling up to overlay
      event.stopPropagation();

      const variantId = this.getAttribute('data-variant-id');

      // Call the removeFromCart function with the variant ID and button reference
      await removeFromCart(variantId, this);
    });
  });
}
